import { Component, HostBinding, Input } from "@angular/core";

export enum SvgIcon {
  FLAG_CHECKERED = "FLAG_CHECKERED",
  GEM = "GEM",
  FACE_SAD_TEAR = "FACE_SAD_TEAR",
  ROTATE = "ROTATE",
  TOWER_CELL = "TOWER_CELL",
}

@Component({
  selector: "app-responsive-icon",
  standalone: true,
  imports: [],
  templateUrl: "./responsive-icon.component.html",
  styleUrl: "./responsive-icon.component.scss",
})
export class ResponsiveIconComponent {
  @Input() icon!: SvgIcon;

  @HostBinding("class") get getClass(): string {
    return this.icon;
  }
}
